import gql from 'graphql-tag';

export const UNPAUSE_BULK_AFFILIATE_OFFERS_LINK_ASYNC = gql`
  mutation UnpauseBulkAffiliateOfferLinksAsync($ids: [Int!]!) {
    unpauseBulkAffiliateOfferLinksAsync(ids: $ids)
  }
`;
